import { render } from "./ReporteContratos.vue?vue&type=template&id=2bc8996d"
import script from "./ReporteContratos.vue?vue&type=script&lang=js"
export * from "./ReporteContratos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__